import React from 'react'
import Table from 'UI/Table'
import ActionColumn from 'UI/Table/components/ActionColumn'
import EditableColumn from 'UI/Table/components/EditableColumn'

class AssetTypesSubTable extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      fields: {
        id: null,
        managed_by_calligo: null,
        name: null,
        asset_category_id: null,
        monitoring_type_values: [],
        something_location: null
      },
    }
  }

  updateState = (newState) => {
    var result = newState

    if (typeof newState === 'function') {
      result = newState(this.state);
    }

    if (result && result.fields !== undefined) {
      const { managed_by_calligo } = result.fields;
  
      switch (managed_by_calligo) {
        case 'Calligo Managed':
          result.fields.managed_by_calligo = true;
          break;
        case 'Shared':
          result.fields.managed_by_calligo = undefined;
          break;
        case 'Customer':
          result.fields.managed_by_calligo = false;
          break;
        default:
          break;
      }
    }

    this.setState(newState)
  }

  render () {
    const { assetTypes, filterOptions } = this.props
    const { fields, loading } = this.state
    const { updateState } = this

    return (
      <Table {...{
        data: assetTypes,
        loading: loading,
        columns: [
          { Header: '', maxWidth: 80, Cell: (row) => <ActionColumn {...{ row, fields, updateState, url: '/assets/types', options: assetTypes, arrayName: 'assetTypes' }} />, filterable: false },
          { Header: 'Code', accessor: 'code' },
          { Header: 'Name', accessor: 'name', Cell: row => <EditableColumn {...{ row, type: 'text', fields, updateState }} /> },
          { Header: 'Calligo Management', accessor: 'managed_by_calligo', Cell: row => <EditableColumn {...{ row, type: 'select', fields, updateState, options: filterOptions.calligoManagement }} /> },
          { Header: 'Service Category', accessor: 'asset_category_name', Cell: row => <EditableColumn {...{ fieldName: 'asset_category_id', row, type: 'select', fields, updateState, options: filterOptions.assetCategory }} /> },
          { Header: 'Data Protection Coverage', accessor: 'data_protection_coverage', Cell: row => <EditableColumn {...{ row, type: 'select', fields, updateState, options: filterOptions.dataProtection }} /> },
          { Header: 'Monitoring Coverage', accessor: 'monitoring_coverage', Cell: row => <EditableColumn {...{ row, type: 'select', fields, updateState, options: filterOptions.monitoring }} /> },
          { Header: 'Antivirus Coverage', accessor: 'antivirus_coverage', Cell: row => <EditableColumn {...{ row, type: 'select', fields, updateState, options: filterOptions.antiVirus }} /> },
          { Header: 'Patching Coverage', accessor: 'patching_coverage', Cell: row => <EditableColumn {...{ row, type: 'select', fields, updateState, options: filterOptions.patching } } /> },
          { Header: 'Monitoring Types', accessor: 'monitoring_type_values', Cell: row => <EditableColumn {...{ row, type: 'multiselect', fields, updateState, options: filterOptions.monitoringType } } /> },
          { Header: 'Incognita Data Source', accessor: 'something_location', Cell: row => <EditableColumn {...{ row, type: 'text', fields, updateState }} /> }
        ],
        filterable: true,
        defaultPageSize: assetTypes.length,
        showPagination: false
      }} />
    )
  }
}

export default AssetTypesSubTable
